"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importDefault(require("styled-components"));
var PageRoot_1 = require("./PageRoot");
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\n\t/* Don't overlap with other modal elements, only show the newest */\n\tdisplay: none;\n\t&:last-child {\n\t\tdisplay: block;\n\t}\n"], ["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\n\t/* Don't overlap with other modal elements, only show the newest */\n\tdisplay: none;\n\t&:last-child {\n\t\tdisplay: block;\n\t}\n"])));
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.root = null;
        return _this;
    }
    Modal.prototype.render = function () {
        if (!this.root) {
            this.root = document.getElementById(PageRoot_1.ModalRootId);
            if (!this.root) {
                return null;
            }
        }
        return react_dom_1.default.createPortal(react_1.default.createElement(Container, null, this.props.children), this.root);
    };
    Modal.propTypes = {
        children: prop_types_1.default.node.isRequired,
    };
    Modal.defaultProps = {
        children: '',
    };
    return Modal;
}(react_1.Component));
exports.default = Modal;
var templateObject_1;
//# sourceMappingURL=Modal.js.map